import './animation.css';
import Logo from '../../images/logo.png'

const Animations = () => {
    return (
        <>
            <div className='container-animation'>
                <img src={Logo} alt="Logo OG1" />
                <div className='circle'>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <p>Aguarde, carregando as informações!</p>
            </div>
        </>
    );
};

export default Animations;